	
function contentColumns(){
		$('.m__content-columns__col-wrapper.use-slick').each(function(){
			$(this).slick({
				autoplay: false,
		  		slidesToShow: $(this).data("num-cols"),
		  		slidesToScroll: $(this).data("num-cols"),
		  		arrows:true,
		  		dots: true,
		  		infinite: false,
		  		responsive: [
		  		    {
		  		      breakpoint: 999,
		  		      settings: {
		  		        slidesToShow: 1,
		  		        slidesToScroll: 1,
		  		        dots: true
		  		      }
		  		    },
		  		]
			});
		});

}
	